<template>
  <div class="_additional-message-info">
    <h4 class="_section-title">
      เปิดบัญชีใหม่
    </h4>
    <p class="_section-content">
      ลูกค้าต้องการเปิดบัญชี LINE OA ใหม่ และซื้อแพ็กเกจกับ Sellsuki
    </p>
  </div>
</template>

<script>
export default {
  name: 'TransferLineOfficialAccountNewInfo'
}
</script>

<style lang="scss" scoped>
._additional-message-info {
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-family: "Prompt", sans-serif;
}

._section-title {
  font-family: "Prompt", sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 1.4;
  letter-spacing: 0%;
  color: #000000;
  margin: 0;
}

._section-content {
  font-family: "Prompt", sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.5;
  letter-spacing: 0%;
  color: #666666;
  margin: 0;
}
</style>
